<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">
      <!-- :cell-class-name="tableCellClassName" -->
      <el-table-column align="center" prop="name" min-width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="nameNum"
        label="次数"
        min-width="180"
      >
      </el-table-column>
    </el-table>
    <div class="tableContent">
      <div>总结：</div>
      <div>
        本月活动内容主要集中在会议、公开课筹备。
        在研修、培训等活动内容还需要加强。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: "公开课",
          nameNum: "23",
        },
        {
          name: "研修",
          nameNum: "21",
        },
        {
          name: "讲座",
          nameNum: "10",
        },
        {
          name: "培训",
          nameNum: "9",
        },
      ],
    };
  },
  //   methods:{
  //     tableCellClassName({ column, columnIndex }) {
  //       if (columnIndex) {
  //         return "even_row";
  //       } else {
  //         return "";
  //       }
  //     },
  //   },
};
</script>

<style scoped>
.el-table{
    margin: 20px 0;
}
.el-table >>> .has-gutter tr th,
.el-table >>> .el-table__row > td:first-child {
  background: #f2f2f2;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/studio/components/actTypeTable.vue